import React from 'react'
import Link from '../../Link'

interface SignUpCardProps {
    img: string
    title: string
    listItems: string[]
    to: string
    buttonText: string
}

const SignUpCard: React.FC<SignUpCardProps> = ({
    img,
    title,
    listItems,
    to,
    buttonText
}) => {
    return (
        <div className="r-type">
            <div className="section-spacing icon"><img src={img} alt={title} /></div>
            <h5 className="font-weight-bolder">{title}</h5>
            <ul className="section-spacing signup-card_list-item body text-left">
                {listItems.map(l => <li>{l}</li>)}
            </ul>
            <Link to={to} className="btn btn-dark action-button buyer-button">
                {buttonText}
            </Link>
        </div>
    )
}

export default SignUpCard
